@if (!active) {
  <p>
    <i>No visualization available</i>
  </p>
}
<div id="visTab">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" (navChange)="onNavChange($event)" class="nav-tabs">
    @if (isTabVisible("spreadsheet")) {
      <li [ngbNavItem]="getTabId('spreadsheet')">
        <a ngbNavLink>Spreadsheet</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-spreadsheet-visualization
              [dataset]="selectionService.selectedDatasets[0]"
              [sessionData]="sessionData"></ch-spreadsheet-visualization>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("text")) {
      <li [ngbNavItem]="getTabId('text')">
        <a ngbNavLink>Text</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-text-visualization
              [dataset]="selectionService.selectedDatasets[0]"
              [modalMode]="false"></ch-text-visualization>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("expressionprofile")) {
      <li [ngbNavItem]="getTabId('expressionprofile')">
        <a ngbNavLink>Expression Profile</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-expression-profile [dataset]="selectionService.selectedDatasets[0]"></ch-expression-profile>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("image")) {
      <li [ngbNavItem]="getTabId('image')">
        <a ngbNavLink>Image</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-image-visualization [dataset]="selectionService.selectedDatasets[0]"></ch-image-visualization>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("pdf")) {
      <li [ngbNavItem]="getTabId('pdf')">
        <a ngbNavLink>
          <i class="far fa-file-pdf"></i>
          PDF
        </a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-pdf-visualization [dataset]="selectionService.selectedDatasets[0]"></ch-pdf-visualization>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("html")) {
      <li [ngbNavItem]="getTabId('html')">
        <a ngbNavLink>HTML</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-htmlvisualization [dataset]="selectionService.selectedDatasets[0]"></ch-htmlvisualization>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("scatterplot")) {
      <li [ngbNavItem]="getTabId('scatterplot')">
        <a ngbNavLink>Scatter Plot</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-scatter-plot [dataset]="selectionService.selectedDatasets[0]"></ch-scatter-plot>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("volcanoplot")) {
      <li [ngbNavItem]="getTabId('volcanoplot')">
        <a ngbNavLink>Volcano Plot</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-volcano-plot [dataset]="selectionService.selectedDatasets[0]"></ch-volcano-plot>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("phenodata")) {
      <li [ngbNavItem]="getTabId('phenodata')">
        <a ngbNavLink>Phenodata</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-phenodata-visualization
              [dataset]="selectionService.selectedDatasets[0]"
              [datasetsMap]="sessionData.datasetsMap"></ch-phenodata-visualization>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("new-tab")) {
      <li [ngbNavItem]="getTabId('new-tab')">
        <a ngbNavLink>
          <!-- <i class="fas fa-external-link-alt"></i> -->
          Open in New Tab
        </a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-new-tab-visualization [dataset]="selectionService.selectedDatasets[0]"></ch-new-tab-visualization>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("details")) {
      <li [ngbNavItem]="getTabId('details')">
        <a ngbNavLink>Details</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-details-visualization
              [datasets]="selectionService.selectedDatasets"
              [sessionData]="sessionData"
              [tools]="tools"></ch-details-visualization>
          </div>
        </ng-template>
      </li>
    }

    @if (isTabVisible("venn")) {
      <li [ngbNavItem]="getTabId('venn')">
        <a ngbNavLink>Venn Diagram</a>
        <ng-template ngbNavContent>
          <div class="visualization-panel">
            <ch-venn-diagram [selectedDatasets]="selectionService.selectedDatasets"></ch-venn-diagram>
          </div>
        </ng-template>
      </li>
    }
  </ul>

  <div [ngbNavOutlet]="nav"></div>
</div>
